import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { NewBannerAreaComponent } from './new-banner-area/new-banner-area.component';
import { DialogConfirmComponent } from '../dialog-confirm/dialog-confirm.component';
import { EditBannerAreaComponent } from './edit-banner-area/edit-banner-area.component';
import * as moment from 'moment';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'vex-banner-area',
  templateUrl: './banner-area.component.html',
  styleUrls: ['./banner-area.component.scss']
})
export class BannerAreaComponent implements OnInit {
  searchCtrl = new UntypedFormControl();
  pageSize = 10;
  pageNumber = 1;
  pageSizeOptions: number[] = [5, 10, 15, 50];
  lunghezza: any;
  dataSource: MatTableDataSource<any> | null
  displayedColumns: string[] = ['title', 'description', 'publishDate', 'expireDate', 'valid', 'index', 'ref', 'actions'];
  banners;
  @ViewChild(MatTable) table: MatTable<any>;
  icon = {
      "faCircle": faCircle
  }
  flags = {
    EN: 'flag:united-states',
    IT: 'flag:italy'
  };

  constructor(public translate: TranslateService, public guiService: GuiService, private restService: RestService, private dialog: MatDialog) { }

  ngOnInit(): void {
    if (this.guiService.userLogged) {
      this.search();
    } else {
      this.getCurrent();
    }
  }

  getCurrent() {
    this.restService.getService('current_user', '').subscribe((ris) => {
      this.guiService.userLogged = ris;
      this.search();
    })
  }

  search(){
    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.dataSource = new MatTableDataSource();
    const param = {
      page: this.pageNumber,
      size: this.pageSize,
      userId: this.guiService.userLogged.user.id
    };
    this.searchCtrl.value && this.searchCtrl.value !== '' ? (param['langKey'] = this.translate.currentLang, param['i18nTitleFilter'] = this.searchCtrl.value) : null;

    this.restService.postService('node', '/banner-list',param).subscribe((ris)=>{
      this.banners = ris.items;
      this.lunghezza = ris.totalItems
      this.dataSource.data = this.banners;
      this.table ? this.table.renderRows() : null;
      this.guiService.showSpinner = false
    })
  }

  reload() {
    this.searchCtrl.reset();

    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.dataSource = new MatTableDataSource();
    const param = {
      page: 1,
      size: this.pageSize,
      userId: this.guiService.userLogged.user.id
    };
    this.restService.postService('node', '/banner-list',param).subscribe((ris)=>{
      this.banners = ris.items;
      this.lunghezza = ris.totalItems
      this.dataSource.data = this.banners;
      this.table ? this.table.renderRows() : null;
      this.guiService.showSpinner = false
    })
  }

  resetPage() {
    this.pageNumber = 1;
  }

  onPageChanged(pageEvent: PageEvent) {
    this.pageNumber = pageEvent.pageIndex + 1;
    this.pageSize = pageEvent.pageSize;
    this.search();
  }

  createBanner() {
    this.dialog.open(NewBannerAreaComponent, {
      height: '85vh',
      panelClass: 'custom-modalboxx',
      disableClose: true,
      hasBackdrop: true
    }).afterClosed().subscribe((sub) => {
      if (sub == 'done') {
        this.search();
      }
    })
  }

  deleteBanner(id) {
    this.dialog.open(DialogConfirmComponent, {
      width: '250px',
      enterAnimationDuration: '0ms',
      exitAnimationDuration: '1ms',
      panelClass: 'dialog-modalbox',
      data: {
        type: 'node-delete-banner',
        id: id
      }
    }).afterClosed().subscribe((ris) => {
      if (ris != 'true') {
        this.search()
      }
    })
  }

  editBanner(item?: any['item']) {
    this.dialog.open(EditBannerAreaComponent, {
      data: item || null,
      height: '85vh',
      panelClass: 'custom-modalboxx',
      disableClose: true,
      hasBackdrop: true
    }).afterClosed().subscribe((program) => {
      if (program == 'done') {
        this.search()
      }
    })
  }

  isValid(start, end): boolean{
    const startDate = moment(start);
    const endDate = moment(end);
    const today = moment();

    return today.isSameOrAfter(startDate) && today.isBefore(endDate)
  }

}
